import Text from "components/base/Text";
import getSimpleDate from "utils/format";
import { useRouter } from "next/router";

const Date = ({ date, ...props }) => {
  const router = useRouter();
  const { locale } = router;
  return (
    <Text type="title_sm" {...props} color="gray.400" textTransform="uppercase">
      {getSimpleDate(date, locale)}
    </Text>
  );
};

export default Date;
